import React from 'react';
import { UserCheck, Users } from '@/utils/icons';

interface CodesTabProps {
    selectedTeam: any;
    isDark: boolean;
    copiedCode: string;
    copyToClipboard: (text: string) => void;
}

const CodesTab: React.FC<CodesTabProps> = ({ selectedTeam, isDark, copiedCode, copyToClipboard }) => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
            {/* Coach Code */}
            <div className="cgm-card rounded-2xl p-8 text-center" data-tour="codes-coach-code">
                <div className="flex items-center justify-center mb-6">
                    <UserCheck className="w-12 h-12 cgm-icon-data" />
                </div>
                <h4 className="text-2xl font-bold cgm-text-primary mb-3">Coach Code</h4>
                <p className="cgm-text-secondary text-sm mb-6">
                    Share this code with coaches to join your team
                </p>
                <div className="font-code cgm-code-display p-4 mb-4">
                    <div className="text-3xl font-bold cgm-text-primary tracking-wider">
                        {selectedTeam.coach_code}
                    </div>
                </div>
                <button
                    onClick={() => copyToClipboard(selectedTeam.coach_code)}
                    className={`w-full px-4 py-3 rounded-xl font-semibold transition-all duration-200 ${
                        copiedCode === selectedTeam.coach_code
                            ? 'bg-green-500/10 dark:bg-green-500/20 shadow-[inset_0_2px_4px_rgba(34,197,94,0.3)] border border-green-500/30 text-green-600 dark:text-green-400'
                            : 'cgm-button shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:shadow-[0_4px_8px_rgba(0,0,0,0.15)] hover:-translate-y-1 active:translate-y-0 active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.15)]'
                    }`}
                >
                    {copiedCode === selectedTeam.coach_code ? 'Copied!' : 'Copy Code'}
                </button>
            </div>
        </div>

        <div>
            {/* Athlete Code */}
            <div className="cgm-card rounded-2xl p-8 text-center" data-tour="codes-athlete-code">
                <div className="flex items-center justify-center mb-6">
                    <Users className="w-12 h-12 cgm-icon-success" />
                </div>
                <h4 className="text-2xl font-bold cgm-text-primary mb-3">Athlete Code</h4>
                <p className="cgm-text-secondary text-sm mb-6">
                    Share this code with athletes to join your team
                </p>
                <div className="font-code cgm-code-display p-4 mb-4">
                    <div className="text-3xl font-bold cgm-text-primary tracking-wider">
                        {selectedTeam.athlete_code}
                    </div>
                </div>
                <button
                    onClick={() => copyToClipboard(selectedTeam.athlete_code)}
                    className={`w-full px-4 py-3 rounded-xl font-semibold transition-all duration-200 ${
                        copiedCode === selectedTeam.athlete_code
                            ? 'bg-green-500/10 dark:bg-green-500/20 shadow-[inset_0_2px_4px_rgba(34,197,94,0.3)] border border-green-500/30 text-green-600 dark:text-green-400'
                            : 'cgm-button shadow-[inset_0_2px_4px_rgba(0,0,0,0.1)] hover:shadow-[0_4px_8px_rgba(0,0,0,0.15)] hover:-translate-y-1 active:translate-y-0 active:shadow-[inset_0_2px_4px_rgba(0,0,0,0.15)]'
                    }`}
                >
                    {copiedCode === selectedTeam.athlete_code ? 'Copied!' : 'Copy Code'}
                </button>
            </div>
        </div>
    </div>
);

export default CodesTab;
